export function isKey<T extends {}>(o: T, k: unknown): k is keyof T {
  return typeof k === 'string' && Object.keys(o).includes(k)
}

export function isElement(x: unknown): x is React.ReactElement {
  return !!(x && {}.hasOwnProperty.call(x, 'props'))
}

export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined
}
